export default __webpack_public_path__ + "static/media/trashcan.56aeb2d8.svg";